const questionsCH = [
  {
    id: "1ton_cow",
    type: "single",
    answers: ["eighty", "hundred_and_ten", "two_hundred_and_fifty"],
    correctAnswers: ["eighty"],
    image: "Grafik_Kuh_Frage_1",
  },
  {
    id: "1ton_heat",
    type: "single",
    answers: ["forty", "ninety_five", "fifty_five"],
    correctAnswers: ["fifty_five"],
    image: "Grafik_Haus_Frage_1",
  },
  {
    id: "1ton_electric",
    type: "single",
    answers: ["two_hundred", "five_hundred", "three_hundred_and_fifty"],
    correctAnswers: ["three_hundred_and_fifty"],
    image: "Grafik_Elektrogeraete_Frage_1",
  },
  {
    id: "1ton_flight",
    type: "single",
    answers: ["budapest", "nairobi", "tel_aviv"],
    correctAnswers: ["tel_aviv"],
    image: "Grafik_Erde_Frage_1",
  },
  {
    id: "digital_footprint",
    type: "sort",
    answers: ["search_engine", "cloud_storage", "streaming", "machines"],
    correctAnswers: ["streaming", "cloud_storage", "machines", "search_engine"],
    image: "Grafik_Computer_Frage_2",
  },
  {
    id: "packaging",
    type: "single",
    answers: ["cup", "coffee"],
    correctAnswers: ["coffee"],
    image: "Grafik_Kaffe_Frage_3",
  },
  {
    id: "sectors",
    type: "sort",
    answers: [
      "industry",
      "agriculture",
      "other",
      "cars",
      "other_mobility",
      "households",
      "flights",
      "waste",
    ],
    correctAnswers: [
      "industry",
      "cars",
      "households",
      "agriculture",
      "flights",
      "other_mobility",
      "waste",
      "other",
    ],
    image: "Grafik_Diagramm_Frage_4",
  },
  {
    id: "food_waste_potential",
    type: "single",
    answers: ["meat", "milk", "rice"],
    correctAnswers: ["meat"],
    image: "Grafik_Foodwaste_Frage_5",
  },
  {
    id: "food_waste_cars",
    type: "single",
    answers: ["sixty_five_thousand", "five_hundred_thousand"],
    correctAnswers: ["five_hundred_thousand"],
    image: "Grafik_Foodwaste_Frage_5",
  },
  {
    id: "tshirt",
    type: "single",
    answers: ["eighty_percent", "forty_percent", "twenty_percent"],
    correctAnswers: ["eighty_percent"],
    image: "Grafik_Tshirt_Frage_6",
  },
  {
    id: "carbon_increase",
    type: "single",
    answers: ["ten_percent", "thirty_percent", "twenty_percent"],
    correctAnswers: ["thirty_percent"],
    image: "Grafik_Molekuel_Frage_7",
  },
  {
    id: "carbon_history",
    type: "multiple",
    answers: ["wobbly", "massive_increase", "not_relevant", "global", "human"],
    correctAnswers: ["wobbly", "massive_increase", "human"],
    image: "Grafik_Molekuel_Frage_7",
  },
];

const quizQuestions = (language) => {
  switch (language) {
    case "de-DE":
    case "en-DE":
      return questionsCH.filter((question) => question.id !== "sectors");
    case "de-CH":
    case "en-CH":
    case "fr":
      return questionsCH;
    default:
      throw "language "+language+ "is not supported"
  }
};

export default quizQuestions;
